<script setup lang="ts">
import { computed, type Component } from 'vue';
import { AppThemeModel, resolveAppTheme } from '../../../../common/src';
import store from '@/store';
import DefaultHeader from './header.component.vue';
import SableHeader from './sable-theme/sable-header.component.vue';

const headerRegistry: Record<AppThemeModel, Component> = {
  default: DefaultHeader,
  sable: SableHeader,
};

defineProps<{ hideHeader?: boolean }>();

const activeHeader = computed(() => headerRegistry[resolveAppTheme(store.state.config?.themecustomization.theme)]);
</script>

<template>
  <component :is="activeHeader" :hide-header="hideHeader" />
</template>
